import { Suspense } from 'react';
import { branch, compose, renderNothing } from 'recompose';
import { LoadRemote } from '@mindtickle/ui-shell-core/DynamicRemote';
import { withSnowPlow as withSnowplow } from '~/components/Snowplow';

import globalEnv from '~/config/env';
import { isAdminSite } from '~/utils';
import { withTranslationsInternal } from '~/components/Intl';
import { withRelay } from '~/components/Relay';
import { APP_NAME, DYNAMIC_REMOTES } from '~/config/app.constants';
import Loader from './Loader';
import { useSidebarVisibility } from './hooks/useSidebarVisibility';

const Sidebar = () => {
  const isVisible = useSidebarVisibility();

  if (isVisible) {
    return (
      <Suspense fallback={<span />}>
        <LoadRemote
          remote={DYNAMIC_REMOTES.LEARNER_SIDEBAR}
          loader={<Loader />}
          lazy={false}
          onIdleEnabled={false}
        />
      </Suspense>
    );
  }
  return null;
};

export default compose(
  branch(() => !!isAdminSite(), renderNothing),
  withTranslationsInternal({
    appName: DYNAMIC_REMOTES.LEARNER_SIDEBAR.appName,
    loader: <Loader />,
  }),
  withSnowplow({
    collectorUrl: globalEnv.RXP_SVC_SNOWPLOW_INGRESS,
    namespace: APP_NAME,
  }),
  withRelay({
    enableSubscription: false,
    graphqlEndpoint: globalEnv.READINESS_GQL_API_ENDPOINT,
  })
)(Sidebar);
